import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { ServiceCard } from './ServiceCard';
import { additionalCapabilities, services } from '../data/services';
import { linkTargetProps } from '../utils/links';
export function ServicesSection() {
  return <section id="services" aria-labelledby="services-heading" className="bg-paper py-14 md:py-28" data-id="element-367" data-mp="2l8wqyycv8haq">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12" data-id="element-368" data-mp="26ka48bkwsn9h">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end lg:gap-12" data-id="element-369" data-mp="2bb8m3fljpteu">
          <div className="lg:col-span-7" data-id="element-370" data-mp="2bcjtdpe79jap">
            <Eyebrow data-id="element-371" data-mp="1xkdlsrp44kmv">The right repair for your truck</Eyebrow>
            <h2 id="services-heading" className="mt-5 font-display text-[40px] font-bold uppercase leading-[0.95] text-ink md:text-[56px] lg:text-[64px]" data-id="element-372" data-mp="1xhr5a2k8uusi">
              Bodywork for{' '}
              <br data-id="element-373" data-mp="1skhgmp4oin5q" />
              vehicles that work.
            </h2>
          </div>
          <p className="max-w-[34rem] text-[17px] leading-relaxed text-steel lg:col-span-5 lg:pb-2" data-id="element-374" data-mp="2pnb0hbm2kto5">
            We repair and refinish working vehicles — semi cabs and hoods, box truck bodies, fleet units, trailers and
            RVs. Pick a service to learn more, or send the details to start a quote.
          </p>
        </div>

        <ul className="mt-12 grid gap-px border border-line bg-line sm:grid-cols-2 md:mt-16 lg:grid-cols-3" data-id="element-375" data-mp="2um4fj8h08sqf">
          {services.map(service => <li key={service.title} className="flex" data-id="element-376" data-mp="26up50sf2r543">
              <ServiceCard service={service} data-id="element-377" data-mp="21yrpupfjs4sw" />
            </li>)}
        </ul>

        <div id="capabilities" className="flex flex-col gap-4 border-x border-b border-line bg-paper-deep px-7 py-6 md:flex-row md:items-center md:gap-8 md:px-9" data-id="element-378" data-mp="2fpdc8o47mwvj">
          <h3 className="shrink-0 text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-deep" data-id="element-379" data-mp="1n8aof62wxew0">
            Additional capabilities
          </h3>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[15px] text-ink" data-id="element-380" data-mp="1j54mubqqwbvv">
            {additionalCapabilities.map((cap, i) => <li key={cap.label} className="flex items-center gap-5" data-id="element-381" data-mp="3naa978cmneab" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" className="h-3.5 w-px bg-steel/40" data-id="element-382" data-mp="3s2205jzp3m0z" />}
                {cap.href ? <a href={cap.href} {...linkTargetProps(cap.href)} className="inline-flex min-h-[44px] items-center gap-1 font-medium underline decoration-line decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-brand" data-id="element-383" data-mp="vqwdg3aw75y">
                    {cap.label}
                    <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-384" data-mp="3eadrxrskhhpa" />
                  </a> : <span data-id="element-385" data-mp="ollb6376k5su">{cap.label}</span>}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}